var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWrongpersonunibox = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.3125 10L13.4375 13.125M13.4375 10L10.3125 13.125M7.5 9.6875H4.6875C3.81527 9.6875 3.37916 9.6875 3.02429 9.79515C2.22528 10.0375 1.60003 10.6628 1.35765 11.4618C1.25 11.8167 1.25 12.2528 1.25 13.125M9.0625 4.6875C9.0625 6.2408 7.8033 7.5 6.25 7.5C4.6967 7.5 3.4375 6.2408 3.4375 4.6875C3.4375 3.1342 4.6967 1.875 6.25 1.875C7.8033 1.875 9.0625 3.1342 9.0625 4.6875Z",
  stroke: "#007AFF",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWrongpersonunibox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wrongpersonunibox.6627b3cf3eef7366bec13403122a34eb.svg";